export default __webpack_public_path__ + "static/media/css-3-svgrepo-com.f1823d86.svg";